import { render, staticRenderFns } from "./SysMailGroup.vue?vue&type=template&id=25123784&scoped=true&"
import script from "./SysMailGroup.vue?vue&type=script&lang=js&"
export * from "./SysMailGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25123784",
  null
  
)

export default component.exports